import React, { } from 'react';
import { useParams } from 'react-router-dom';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { Action, CollectionServerMobile, DropdownMobile, Field, GET, GetMetaProperties, JSXMap, Model, ModelMobile, POST, SetMetaProperties, deleteInArray, deleteInProperties, errorCatch, foreachInProperties, getObjectDisplay, updateInArray, updateInPropertiesUUID, useAuth, useMetaContext } from 'fennec-ui';

import PageLayout from '../../../../components/PageLayout';
import { useBreadcrumbs, useMenuLevelOneContext, useMenuLevelThreeContext, useMenuLevelTwoContext, useSchoolContext } from '../../../../../common/Context';
import CapsuleMenu from '../../../../components/CapsuleMenu';
import ObjectOwnerDescription from '../../../../../fedance-ui/ObjectOwnerDescription';
import { Empty } from 'antd';
import Icofont from 'react-icofont';
import { Modal, Toast } from 'antd-mobile';
import { MoreOutlined } from '@ant-design/icons';

var _ = require('lodash');

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

export default function Settings(props) {
    let { id } = useParams();
    const auth = useAuth();
    const meta = useMetaContext();

    // const sourceKey = "promouter";
    // const [event, setEvent] = useState(undefined);
    // useEffect(() => {
    //     GET(auth, `/api/meropriyatiya/list/${sourceKey}?detail=model&w-id=${id}`,
    //         ({ data }) => {
    //             if (data && data.length) {
    //                 setEvent(data[0]);
    //             }
    //         }, errorCatch);
    // }, [])

    const [school, setSchool] = useSchoolContext()
    const osnovi = _.get(school, "osnoviPromokodovShkolaFederatsii[0]")

    // ----------------------------------------
    const breadcrumbs = useBreadcrumbs()
    const menuLevelOne = useMenuLevelOneContext()
    const menuLevelTwo = useMenuLevelTwoContext()
    const menuLevelThree = useMenuLevelThreeContext()
    const getLast = (path) => {
        if (!path) return;
        var loc_array = path.split("/")
        var lst = loc_array[loc_array.length - 1]
        if (!lst) return;
        return lst
    }
    const getBase = (path) => {
        if (!path) return;
        var loc_array = path.split("/")
        var lst = loc_array.slice(0, -1)
        return lst.join("/")
    }
    const getLevel = (arr, i) => {
        let p = "/app"
        var count = 0;
        for (let idx = 0; idx < arr.length; idx++) {
            if (count >= i) return p;
            if (!arr[idx]?.context) {
                count++
            }
            p += `/${arr[idx]?.uuid}`
        }
        return p
    }
    // ----------------------------------------
    let metaEmailShkol = _.get(meta, "EmailShkol");
    let metatelefonishkol = _.get(meta, "TelefoniShkol");
    let metasaitishkol = _.get(meta, "SaitiShkol");
    let metaadresashkol = _.get(meta, "AdresaShkol");

    const propertiesFromMeta = React.useCallback((name, funcs) => {
        let prop = [];
        // let p = _.get(meta[name], "properties");
        let p = GetMetaProperties(meta[name])
        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt", "Creator", "ID"])
        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }
        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop;
    }, [meta]);
    const filtersFromMeta = React.useCallback((name, funcs) => {
        let prop = [];
        // let p = _.get(meta[name], "properties");
        let p = GetMetaProperties(meta[name])
        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt", "Creator", "ID"])
        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }
        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop;
    }, [meta]);
    const cleanProperties = (obj, context, funcs) => {
        const { name, field, fieldName, contextObject, object } = context;
        if (!obj) { return obj }
        let p = GetMetaProperties(obj)
        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt"])
        if (object && obj.type == "object") {
            p = updateInPropertiesUUID(p, {
                uuid: "object-owner-description",
                type: "func",
                render: () => (<ObjectOwnerDescription object={object} style={{ marginBottom: "5px" }} />)
            }, true)
        }
        if (contextObject && obj.type == "object" && field) {
            let fName = _.get(field, "relation.reference.property");
            let o = obj?.properties?.find(e => e.name == fName)
            if (o) {
                let oObj = _.get(o, "relation.reference.object");
                let oMeta = meta[oObj];
                p = updateInPropertiesUUID(p, {
                    uuid: "object-context-description",
                    type: "func",
                    render: () => (<div className='bg bg-grey' style={{ textAlign: "left", padding: "5px", marginBottom: "5px" }}>
                        {(oMeta) && <div style={{
                            fontSize: "10px",
                            color: "rgb(106, 106, 106)",
                            lineHeight: "10px",
                            fontStyle: "italic"
                        }}>{o?.label} ({oMeta?.label})</div>}
                        <div>{getObjectDisplay(contextObject, oObj, meta)}</div>
                        <div style={{ color: "#6a6a6a" }}><ObjectOwnerDescription object={contextObject} inline={true} /></div>
                    </div>)
                }, true)
            }
        }
        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }

        p = foreachInProperties(p, n => (n.name == "Kommentarii"), {
            type: "text"
        })

        return SetMetaProperties(obj, p)
    }

    return (
        <div className="subcontent">
            <div className={"content"}>
                <PageLayout hideSider={true} >
                    <div style={{ height: "100%", overflowY: "auto", backgroundColor: "white", padding: "4px 10px", borderRadius: "4px" }}>
                        <div className='pb-4'>
                            <div>
                                <div style={{ fontSize: "16px", fontWeight: "bold" }}>Информация о школе</div>
                            </div>
                            <div style={{ borderLeft: "2px solid #dee2e5", padding: "3px 3px 3px 17px" }}>
                                <div>Региональное отделение:
                                    <span style={{ fontStyle: "italic", color: "rgba(0,0,0,0.65)" }}> {school?.regionalnoeOtdelenie?.nazvanie}</span>
                                </div>
                            </div>
                            <div style={{ borderLeft: "2px solid #dee2e5", padding: "3px 3px 3px 17px" }}>
                                {school?.vseTipiPolzovatelei?.filter(e => e?.tipPolzovatelyaID == 18)?.map(e => {
                                    return (<div>Владелец:
                                        <span style={{ fontStyle: "italic", color: "rgba(0,0,0,0.65)" }}> {e?.user?.lastname} {e?.user?.firstname}</span>
                                    </div>)
                                })}
                            </div>
                            <div style={{ borderLeft: "2px solid #dee2e5", padding: "3px 3px 3px 17px" }}>
                                <div>Администраторы: </div>
                                <div style={{ padding: "3px 3px 3px 17px", fontStyle: "italic", color: "rgba(0,0,0,0.65)" }}>
                                    {school?.vseTipiPolzovatelei?.filter(e => e?.tipPolzovatelyaID == 19)?.map(e => {
                                        return (<div>{e?.user?.lastname} {e?.user?.firstname}</div>)
                                    })}
                                </div>
                            </div>
                        </div>
                        <div>
                            <div>
                                <div style={{ fontSize: "16px", fontWeight: "bold" }}>Параметры промокодов</div>
                            </div>
                            <div className='action-inline'>
                                <Action
                                    auth={auth}
                                    okText="Сохранить"
                                    action={(values, unlock, close) => {
                                        if (values?.osnovaPromokoda && values?.osnovaPromokoda !== "") {
                                            POST(auth, (!osnovi) ? `/api/osnovipromokodov/new` : `/api/osnovipromokodov/update`, {
                                                ID: (osnovi) ? osnovi.ID : undefined,
                                                prepodavatelShkoliID: undefined,
                                                shkolaFederatsiiID: school?.ID,
                                                prepodavatelFederatsiiID: undefined,
                                                organizatorFederatsiiID: undefined,
                                                osnovaPromokoda: values?.osnovaPromokoda,
                                            }, ({ data }) => {
                                                setSchool({ ...school, osnoviPromokodovShkolaFederatsii: updateInArray(school?.osnoviPromokodovShkolaFederatsii, data) })
                                                close()
                                            }, (err) => errorCatch(err, () => unlock()))
                                        } else if (osnovi) {
                                            POST(auth, `/api/osnovipromokodov/delete`, {
                                                ID: (osnovi) ? osnovi.ID : undefined,
                                                prepodavatelShkoliID: undefined,
                                                shkolaFederatsiiID: school?.ID,
                                                prepodavatelFederatsiiID: undefined,
                                                organizatorFederatsiiID: undefined,
                                                osnovaPromokoda: values?.osnovaPromokoda,
                                            }, ({ data }) => {
                                                setSchool({ ...school, osnoviPromokodovShkolaFederatsii: [] })
                                                close()
                                            }, (err) => errorCatch(err, () => unlock()))
                                        }

                                    }}

                                    object={osnovi}
                                    // disabledOkOnUncahngedForm={true}

                                    form={ModelMobile}
                                    meta={[
                                        {
                                            label: "Основа промокода",
                                            description: (<span><i className="fa fa-question-circle"></i> Применяется в качестве префикса при выдаче промокода организатором мероприятия</span>),
                                            name: "osnovaPromokoda",
                                            type: "string",
                                            size: "small"
                                        }
                                    ]}
                                    mode={"inline"}
                                />
                            </div>
                        </div>
                        <div style={{ marginTop: "20px" }}>
                            <div>
                                <div style={{ fontSize: "16px", fontWeight: "bold" }}> Параметры школы</div>
                            </div>
                            <div className='action-inline'>
                                <Action
                                    auth={auth}
                                    okText="Сохранить"
                                    action={(values, unlock, close) => {
                                        POST(auth, `/api/school/update`, {
                                            ...school,
                                            ...values
                                        }, ({ data }) => {
                                            setSchool({ ...school, ...data })
                                            close()
                                        }, (err) => errorCatch(err, () => unlock()))
                                    }}

                                    object={school}
                                    // disabledOkOnUncahngedForm={true}
                                    form={ModelMobile}
                                    meta={[
                                        {
                                            label: "Название школы",
                                            name: "nazvanieShkoliTantsev",
                                            type: "string",
                                            size: "small"
                                        },
                                        {
                                            label: "Школа второго уровня",
                                            name: "shkolaVtorogoUrovnya",
                                            type: "bool",
                                            size: "small"
                                        },
                                        {
                                            label: "Процент преподавателям ",
                                            description: (<span><i className="fa fa-question-circle"></i> Процент начисляемый преподавателю по промокоду</span>),
                                            name: "protsentSvoimPrepodavatelyam",
                                            type: "float",
                                            size: "small"
                                        }
                                    ]}
                                    mode={"inline"}
                                />
                            </div>
                            <div style={{ padding: "10px 0" }}>
                                <div style={{ fontSize: "16px", fontWeight: "bold" }}>Контакты школы</div>
                            </div>
                            {(school && metaEmailShkol) && <div style={{ borderLeft: "2px solid #dee2e5", padding: "10px" }}>
                                <div className='bg bg-grey light-3' style={{ fontSize: "14px", fontWeight: "bold", textAlign: "left", marginBottom: "5px", padding: "0 5px" }}>Email</div>
                                <CollectionServerMobile
                                    noheader={true}
                                    auth={auth}
                                    name={"EmailShkol"}
                                    source={`/api/emailshkol/list/${school?.ID}`}
                                    filters={() => []}
                                    // filters={() => filtersFromMeta(metaEmailShkol.name, [
                                    //     (p) => { return deleteInProperties(p, ["Shkola"]) }
                                    //     // (p) => {
                                    //     //     return foreachInProperties(p, n => (n.name == "Strana"), {
                                    //     //         display: (item) => {
                                    //     //             return item?.name
                                    //     //         },
                                    //     //     })
                                    //     // }
                                    // ])}
                                    customRender={(items, {
                                        collection,
                                        setCollection,
                                        setCollectionItem,
                                        removeCollectionItem,
                                        collectionActions,
                                        modelActions,
                                        update,
                                        loading
                                    }) => (
                                        <div style={{ paddingTop: "5px" }}>
                                            {!collection?.length && <div>
                                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Нет данных" />
                                            </div>}
                                            {(collection?.length > 0) && JSXMap(items, (item, idx) => {
                                                return (
                                                    <div key={item?.ID || idx} className={`bg ${(idx % 2 > 0) ? "bg-grey light-15" : "bg-fwhite"} pointer`} style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "2px", textAlign: "left", padding: "0 5px" }}>
                                                        <div style={{ flex: "1 1 auto" }}>
                                                            <div>{item?.email}</div>
                                                        </div>
                                                        <div style={{ flex: "0 0 25px" }}>
                                                            <DropdownMobile
                                                                auth={auth}
                                                                titles={{
                                                                    header: "Адес электронной почты",
                                                                    subheader: (item) ? <div>
                                                                        <div>{item?.email}</div>
                                                                    </div> : "",
                                                                }}
                                                                icon={<MoreOutlined />}
                                                                buttonStyle={{ border: "none" }}

                                                                items={modelActions(item, idx)?.map((e, idx) => ({
                                                                    key: e.key || idx,
                                                                    auth: auth,
                                                                    mode: "MenuItem",
                                                                    object: item,
                                                                    collection: collection,
                                                                    setCollection: setCollection,
                                                                    ...e
                                                                }))} />
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )}
                                    size={"small"}
                                    mode="list"
                                    linksModelActions={"inline"}
                                    collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                        return [{
                                            auth: auth,
                                            mode: "func",
                                            trigger: (click) => (<div onClick={click} className='bg bg-grey border-grey' style={{ maxWidth: "80px" }}>Создать</div>),
                                            titles: {
                                                header: "Создание электронной почты",
                                                subheader: (school) ? <div>
                                                    <div>{school?.nazvanieShkoliTantsev}</div>
                                                </div> : "",
                                            },
                                            // virtualized: false,
                                            action: (values, unlock, close, { collection, setCollection }) => {
                                                POST(auth, `/api/emailshkol/create`, { ...values, shkolaID: school?.ID },
                                                    ({ data }) => {
                                                        setCollection(updateInArray(collection, data));
                                                        close();
                                                    }, (err) => errorCatch(err, unlock)
                                                );
                                            },
                                            // title: "Создать",
                                            form: ModelMobile,
                                            meta: propertiesFromMeta(metaEmailShkol.name, [
                                                (p) => { return deleteInProperties(p, ["Shkola"]) }
                                            ])
                                        }]
                                        // return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }))
                                    }}
                                    modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                        return [
                                            {
                                                action: (values, unlock, close, { collection, setCollection }) => {
                                                    POST(auth, `/api/emailshkol/update`, { ...values, ID: item?.ID, shkolaID: school?.ID },
                                                        ({ data }) => {
                                                            setCollection(updateInArray(collection, data));
                                                            close();
                                                        }, (err) => errorCatch(err, unlock)
                                                    );
                                                },
                                                object: item,
                                                form: ModelMobile,
                                                meta: propertiesFromMeta(metaEmailShkol.name, [
                                                    (p) => { return deleteInProperties(p, ["Shkola"]) }
                                                ]),
                                                title: "Изменить",
                                            },
                                            {
                                                title: <span style={{ color: "red" }}>Удалить</span>,
                                                action: (values, unlock, close, { collection, setCollection }) => {
                                                    Modal.confirm({
                                                        content: <div style={{ padding: "10px 15px" }}>
                                                            <div><span>Вы действительно хотите удалить email?</span></div>
                                                            <div>
                                                                <span style={{ fontSize: "14px", fontWeight: "lighter" }}>
                                                                    {item?.email}
                                                                </span>
                                                            </div>
                                                        </div>,
                                                        cancelText: "Отмена",
                                                        confirmText: "Удалить",
                                                        onCancel: async () => { },
                                                        onConfirm: async () => {
                                                            try {
                                                                return await new Promise((resolve, reject) => {
                                                                    GET(auth, `/api/emailshkol/delete/${item.ID}`,
                                                                        ({ data }) => {
                                                                            Toast.show({
                                                                                icon: 'success',
                                                                                content: 'Готово',
                                                                                position: 'bottom',
                                                                            });
                                                                            // message.success('Готово');
                                                                            setCollection(deleteInArray(collection, item));
                                                                            resolve(data);
                                                                        }, (err) => errorCatch(err, reject));
                                                                });
                                                            } catch { }
                                                        },
                                                    })
                                                },
                                            }
                                        ]
                                        // return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                                    }}
                                />
                            </div>}
                            {(school && metatelefonishkol) && <div style={{ borderLeft: "2px solid #dee2e5", padding: "10px" }}>
                                <div className='bg bg-grey light-3' style={{ fontSize: "14px", fontWeight: "bold", textAlign: "left", marginBottom: "5px", padding: "0 5px" }}>Телефоны</div>
                                <CollectionServerMobile
                                    noheader={true}
                                    auth={auth}
                                    name={"TelefoniShkol"}
                                    source={`/api/telefonishkol/list/${school?.ID}`}
                                    filters={() => []}
                                    // filters={() => filtersFromMeta(metatelefonishkol.name, [
                                    //     (p) => { return deleteInProperties(p, ["Shkola"]) }
                                    //     // (p) => {
                                    //     //     return foreachInProperties(p, n => (n.name == "Strana"), {
                                    //     //         display: (item) => {
                                    //     //             return item?.name
                                    //     //         },
                                    //     //     })
                                    //     // }
                                    // ])}
                                    customRender={(items, {
                                        collection,
                                        setCollection,
                                        setCollectionItem,
                                        removeCollectionItem,
                                        collectionActions,
                                        modelActions,
                                        update,
                                        loading
                                    }) => (
                                        <div style={{ paddingTop: "5px" }}>
                                            {!collection?.length && <div>
                                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Нет данных" />
                                            </div>}
                                            {(collection?.length > 0) && JSXMap(items, (item, idx) => {
                                                return (
                                                    <div key={item?.ID || idx} className={`bg ${(idx % 2 > 0) ? "bg-grey light-15" : "bg-fwhite"} pointer`} style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "2px", textAlign: "left", padding: "0 5px" }}>
                                                        <div style={{ flex: "1 1 auto" }}>
                                                            <div>{item?.nomer}</div>
                                                        </div>
                                                        <div style={{ flex: "0 0 25px" }}>
                                                            <DropdownMobile
                                                                auth={auth}
                                                                titles={{
                                                                    header: "Номер телефона",
                                                                    subheader: (item) ? <div>
                                                                        <div>{item?.nomer}</div>
                                                                    </div> : "",
                                                                }}
                                                                icon={<MoreOutlined />}
                                                                buttonStyle={{ border: "none" }}

                                                                items={modelActions(item, idx)?.map((e, idx) => ({
                                                                    key: e.key || idx,
                                                                    auth: auth,
                                                                    mode: "MenuItem",
                                                                    object: item,
                                                                    collection: collection,
                                                                    setCollection: setCollection,
                                                                    ...e
                                                                }))} />
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )}
                                    size={"small"}
                                    mode="list"
                                    linksModelActions={"inline"}
                                    collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                        return [{
                                            auth: auth,
                                            mode: "func",
                                            trigger: (click) => (<div onClick={click} className='bg bg-grey border-grey' style={{ maxWidth: "80px" }}>Создать</div>),
                                            titles: {
                                                header: "Создание телефона",
                                                subheader: (school) ? <div>
                                                    <div>{school?.nazvanieShkoliTantsev}</div>
                                                </div> : "",
                                            },
                                            action: (values, unlock, close, { collection, setCollection }) => {
                                                POST(auth, `/api/telefonishkol/create`, { ...values, shkolaID: school?.ID },
                                                    ({ data }) => {
                                                        setCollection(updateInArray(collection, data));
                                                        close();
                                                    }, (err) => errorCatch(err, unlock)
                                                );
                                            },
                                            //title: "Создать",
                                            form: ModelMobile,
                                            meta: propertiesFromMeta(metatelefonishkol.name, [
                                                (p) => { return deleteInProperties(p, ["Shkola"]) }
                                            ])
                                        }]
                                        // return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }))
                                    }}
                                    modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                        return [
                                            {
                                                action: (values, unlock, close, { collection, setCollection }) => {
                                                    POST(auth, `/api/telefonishkol/update`, { ...values, ID: item?.ID, shkolaID: school?.ID },
                                                        ({ data }) => {
                                                            setCollection(updateInArray(collection, data));
                                                            close();
                                                        }, (err) => errorCatch(err, unlock)
                                                    );
                                                },
                                                object: item,
                                                form: ModelMobile,
                                                meta: propertiesFromMeta(metatelefonishkol.name, [
                                                    (p) => { return deleteInProperties(p, ["Shkola"]) }
                                                ]),
                                                title: "Изменить",
                                            },
                                            {
                                                title: <span style={{ color: "red" }}>Удалить</span>,
                                                action: (values, unlock, close, { collection, setCollection }) => {
                                                    Modal.confirm({
                                                        content: <div style={{ padding: "10px 15px" }}>
                                                            <div><span>Вы действительно хотите удалить телефон?</span></div>
                                                            <div>
                                                                <span style={{ fontSize: "14px", fontWeight: "lighter" }}>
                                                                    {item?.nomer}
                                                                </span>
                                                            </div>
                                                        </div>,
                                                        cancelText: "Отмена",
                                                        confirmText: "Удалить",
                                                        onCancel: async () => { },
                                                        onConfirm: async () => {
                                                            try {
                                                                return await new Promise((resolve, reject) => {
                                                                    GET(auth, `/api/telefonishkol/delete/${item.ID}`,
                                                                        ({ data }) => {
                                                                            Toast.show({
                                                                                icon: 'success',
                                                                                content: 'Готово',
                                                                                position: 'bottom',
                                                                            });
                                                                            // message.success('Готово');
                                                                            setCollection(deleteInArray(collection, item));
                                                                            resolve(data);
                                                                        }, (err) => errorCatch(err, reject));
                                                                });
                                                            } catch { }
                                                        },
                                                    })
                                                },
                                            }
                                        ]
                                        // return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                                    }}
                                />
                            </div>}
                            {(school && metasaitishkol) && <div style={{ borderLeft: "2px solid #dee2e5", padding: "10px" }}>
                                <div className='bg bg-grey light-3' style={{ fontSize: "14px", fontWeight: "bold", textAlign: "left", marginBottom: "5px", padding: "0 5px" }}>Сайты</div>
                                <CollectionServerMobile
                                    noheader={true}
                                    auth={auth}
                                    name={"SaitiShkol"}
                                    source={`/api/saitishkol/list/${school?.ID}`}
                                    filters={() => []}
                                    // filters={() => filtersFromMeta(metasaitishkol.name, [
                                    //     (p) => { return deleteInProperties(p, ["Shkola"]) },
                                    //     (p) => {
                                    //         return foreachInProperties(p, n => (n.name == "TipSeti"), {
                                    //             display: (item) => {
                                    //                 return item?.nazvanie
                                    //             },
                                    //         })
                                    //     }
                                    // ])}
                                    customRender={(items, {
                                        collection,
                                        setCollection,
                                        setCollectionItem,
                                        removeCollectionItem,
                                        collectionActions,
                                        modelActions,
                                        update,
                                        loading
                                    }) => (
                                        <div style={{ paddingTop: "5px" }}>
                                            {!collection?.length && <div>
                                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Нет данных" />
                                            </div>}
                                            {(collection?.length > 0) && JSXMap(items, (item, idx) => {
                                                return (
                                                    <div key={item?.ID || idx} className={`bg ${(idx % 2 > 0) ? "bg-grey light-15" : "bg-fwhite"} pointer`} style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "2px", textAlign: "left", padding: "0 5px" }}>
                                                        <div style={{ flex: "1 1 auto" }}>
                                                            <div>{item?.url}</div>
                                                        </div>
                                                        <div style={{ flex: "0 0 25px" }}>
                                                            <DropdownMobile
                                                                auth={auth}
                                                                titles={{
                                                                    header: "Адрес сайта",
                                                                    subheader: (item) ? <div>
                                                                        <div>{item?.url}</div>
                                                                    </div> : "",
                                                                }}
                                                                icon={<MoreOutlined />}
                                                                buttonStyle={{ border: "none" }}

                                                                items={modelActions(item, idx)?.map((e, idx) => ({
                                                                    key: e.key || idx,
                                                                    auth: auth,
                                                                    mode: "MenuItem",
                                                                    object: item,
                                                                    collection: collection,
                                                                    setCollection: setCollection,
                                                                    ...e
                                                                }))} />
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )}
                                    size={"small"}
                                    mode="list"
                                    linksModelActions={"inline"}
                                    collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                        return [{
                                            auth: auth,
                                            mode: "func",
                                            trigger: (click) => (<div onClick={click} className='bg bg-grey border-grey' style={{ maxWidth: "80px" }}>Создать</div>),
                                            titles: {
                                                header: "Создание сайта",
                                                subheader: (school) ? <div>
                                                    <div>{school?.nazvanieShkoliTantsev}</div>
                                                </div> : "",
                                            },
                                            action: (values, unlock, close, { collection, setCollection }) => {
                                                POST(auth, `/api/saitishkol/create`, { ...values, shkolaID: school?.ID },
                                                    ({ data }) => {
                                                        setCollection(updateInArray(collection, data));
                                                        close();
                                                    }, (err) => errorCatch(err, unlock)
                                                );
                                            },
                                            //title: "Создать",
                                            form: ModelMobile,
                                            meta: propertiesFromMeta(metasaitishkol.name, [
                                                (p) => { return deleteInProperties(p, ["Shkola"]) },
                                                (p) => {
                                                    return foreachInProperties(p, n => (n.name == "TipSeti"), {
                                                        display: (item) => {
                                                            return item?.nazvanie
                                                        },
                                                    })
                                                }
                                            ])
                                        }]
                                        // return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }))
                                    }}
                                    modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                        return [
                                            {
                                                action: (values, unlock, close, { collection, setCollection }) => {
                                                    POST(auth, `/api/saitishkol/update`, { ...values, ID: item?.ID, shkolaID: school?.ID },
                                                        ({ data }) => {
                                                            setCollection(updateInArray(collection, data));
                                                            close();
                                                        }, (err) => errorCatch(err, unlock)
                                                    );
                                                },
                                                object: item,
                                                form: ModelMobile,
                                                meta: propertiesFromMeta(metasaitishkol.name, [
                                                    (p) => { return deleteInProperties(p, ["Shkola"]) },
                                                    (p) => {
                                                        return foreachInProperties(p, n => (n.name == "TipSeti"), {
                                                            display: (item) => {
                                                                return item?.nazvanie
                                                            },
                                                        })
                                                    }
                                                ]),
                                                title: "Изменить",
                                            },
                                            {
                                                title: <span style={{ color: "red" }}>Удалить</span>,
                                                action: (values, unlock, close, { collection, setCollection }) => {
                                                    Modal.confirm({
                                                        content: <div style={{ padding: "10px 15px" }}>
                                                            <div><span>Вы действительно хотите удалить сайт?</span></div>
                                                            <div>
                                                                <span style={{ fontSize: "14px", fontWeight: "lighter" }}>
                                                                    {item?.url}
                                                                </span>
                                                            </div>
                                                        </div>,
                                                        cancelText: "Отмена",
                                                        confirmText: "Удалить",
                                                        onCancel: async () => { },
                                                        onConfirm: async () => {
                                                            try {
                                                                return await new Promise((resolve, reject) => {
                                                                    GET(auth, `/api/saitishkol/delete/${item.ID}`,
                                                                        ({ data }) => {
                                                                            Toast.show({
                                                                                icon: 'success',
                                                                                content: 'Готово',
                                                                                position: 'bottom',
                                                                            });
                                                                            // message.success('Готово');
                                                                            setCollection(deleteInArray(collection, item));
                                                                            resolve(data);
                                                                        }, (err) => errorCatch(err, reject));
                                                                });
                                                            } catch { }
                                                        },
                                                    })
                                                },
                                            }
                                        ]
                                        // return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                                    }}
                                />
                            </div>}
                            {(school && metaadresashkol) && <div style={{ borderLeft: "2px solid #dee2e5", padding: "10px" }}>
                                <div className='bg bg-grey light-3' style={{ fontSize: "14px", fontWeight: "bold", textAlign: "left", marginBottom: "5px", padding: "0 5px" }}>Адреса</div>
                                <CollectionServerMobile
                                    noheader={true}
                                    auth={auth}
                                    name={"AdresaShkol"}
                                    source={`/api/adresashkol/list/${school?.ID}`}
                                    filters={() => []}
                                    // filters={() => filtersFromMeta(metaadresashkol.name, [
                                    //     (p) => { return deleteInProperties(p, ["Shkola"]) }
                                    //     // (p) => {
                                    //     //     return foreachInProperties(p, n => (n.name == "Strana"), {
                                    //     //         display: (item) => {
                                    //     //             return item?.name
                                    //     //         },
                                    //     //     })
                                    //     // }
                                    // ])}
                                    customRender={(items, {
                                        collection,
                                        setCollection,
                                        setCollectionItem,
                                        removeCollectionItem,
                                        collectionActions,
                                        modelActions,
                                        update,
                                        loading
                                    }) => (
                                        <div style={{ paddingTop: "5px" }}>
                                            {!collection?.length && <div>
                                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Нет данных" />
                                            </div>}
                                            {(collection?.length > 0) && JSXMap(items, (item, idx) => {
                                                return (
                                                    <div key={item?.ID || idx} className={`bg ${(idx % 2 > 0) ? "bg-grey light-15" : "bg-fwhite"} pointer`} style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "2px", textAlign: "left", padding: "0 5px" }}>
                                                        <div style={{ flex: "1 1 auto" }}>
                                                            <div>{(!item?.gorod?.name) ? "" : "г. " + item?.gorod?.name + ", "}{item?.adres}</div>
                                                        </div>
                                                        <div style={{ flex: "0 0 25px" }}>
                                                            <DropdownMobile
                                                                auth={auth}
                                                                titles={{
                                                                    header: "Адрес",
                                                                    subheader: (item) ? <div>
                                                                        <div>{(!item?.gorod?.name) ? "" : "г. " + item?.gorod?.name + ", "}{item?.adres}</div>
                                                                    </div> : "",
                                                                }}
                                                                icon={<MoreOutlined />}
                                                                buttonStyle={{ border: "none" }}

                                                                items={modelActions(item, idx)?.map((e, idx) => ({
                                                                    key: e.key || idx,
                                                                    auth: auth,
                                                                    mode: "MenuItem",
                                                                    object: item,
                                                                    collection: collection,
                                                                    setCollection: setCollection,
                                                                    ...e
                                                                }))} />
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )}
                                    size={"small"}
                                    mode="list"
                                    linksModelActions={"inline"}
                                    collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                        return [{
                                            auth: auth,
                                            mode: "func",
                                            trigger: (click) => (<div onClick={click} className='bg bg-grey border-grey' style={{ maxWidth: "80px" }}>Создать</div>),
                                            titles: {
                                                header: "Создание адреса",
                                                subheader: (school) ? <div>
                                                    <div>{school?.nazvanieShkoliTantsev}</div>
                                                </div> : "",
                                            },
                                            action: (values, unlock, close, { collection, setCollection }) => {
                                                POST(auth, `/api/adresashkol/create`, { ...values, shkolaID: school?.ID },
                                                    ({ data }) => {
                                                        setCollection(updateInArray(collection, data));
                                                        close();
                                                    }, (err) => errorCatch(err, unlock)
                                                );
                                            },
                                            //title: "Создать",
                                            form: ModelMobile,
                                            meta: propertiesFromMeta(metaadresashkol.name, [
                                                (p) => { return deleteInProperties(p, ["Shkola"]) }
                                            ])
                                        }]
                                        // return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }))
                                    }}
                                    modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                        return [
                                            {
                                                action: (values, unlock, close, { collection, setCollection }) => {
                                                    POST(auth, `/api/adresashkol/update`, { ...values, ID: item?.ID, shkolaID: school?.ID },
                                                        ({ data }) => {
                                                            setCollection(updateInArray(collection, data));
                                                            close();
                                                        }, (err) => errorCatch(err, unlock)
                                                    );
                                                },
                                                object: item,
                                                form: ModelMobile,
                                                meta: propertiesFromMeta(metaadresashkol.name, [
                                                    (p) => { return deleteInProperties(p, ["Shkola"]) }
                                                ]),
                                                title: "Изменить",
                                            },
                                            {
                                                title: <span style={{ color: "red" }}>Удалить</span>,
                                                action: (values, unlock, close, { collection, setCollection }) => {
                                                    Modal.confirm({
                                                        content: <div style={{ padding: "10px 15px" }}>
                                                            <div><span>Вы действительно хотите удалить адрес?</span></div>
                                                            <div>
                                                                <span style={{ fontSize: "14px", fontWeight: "lighter" }}>
                                                                    <div>{(!item?.gorod?.name) ? "" : "г. " + item?.gorod?.name + ", "}{item?.adres}</div>
                                                                </span>
                                                            </div>
                                                        </div>,
                                                        cancelText: "Отмена",
                                                        confirmText: "Удалить",
                                                        onCancel: async () => { },
                                                        onConfirm: async () => {
                                                            try {
                                                                return await new Promise((resolve, reject) => {
                                                                    GET(auth, `/api/adresashkol/delete/${item.ID}`,
                                                                        ({ data }) => {
                                                                            Toast.show({
                                                                                icon: 'success',
                                                                                content: 'Готово',
                                                                                position: 'bottom',
                                                                            });
                                                                            // message.success('Готово');
                                                                            setCollection(deleteInArray(collection, item));
                                                                            resolve(data);
                                                                        }, (err) => errorCatch(err, reject));
                                                                });
                                                            } catch { }
                                                        },
                                                    })
                                                },
                                            }
                                        ]
                                        // return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                                    }}
                                />
                            </div>}
                        </div>
                    </div>
                </PageLayout>
            </div>
            <div className={"footer"}>
                <CapsuleMenu menu={menuLevelTwo} path={getLevel(breadcrumbs, 2)} />

                {/* <TabsMenu menu={menuLevelTwo} path={getLevel(breadcrumbs, 2)} /> */}
                {/* <TabsMenu menu={menuLevelThree} path={getLevel(breadcrumbs, 3)} /> */}

            </div>
        </div>


    );
}
